/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Goal_SaveInputs */

const en_us2_exercise_personal_goal_save = /** @type {(inputs: Exercise_Personal_Goal_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save goal`)
};

const pt_br2_exercise_personal_goal_save = /** @type {(inputs: Exercise_Personal_Goal_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar meta`)
};

const es_419_exercise_personal_goal_save = /** @type {(inputs: Exercise_Personal_Goal_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar meta`)
};

const pt_pt2_exercise_personal_goal_save = /** @type {(inputs: Exercise_Personal_Goal_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar objetivo`)
};

const fr_fr2_exercise_personal_goal_save = /** @type {(inputs: Exercise_Personal_Goal_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer l'objectif`)
};

const de_de2_exercise_personal_goal_save = /** @type {(inputs: Exercise_Personal_Goal_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel speichern`)
};

const it_it2_exercise_personal_goal_save = /** @type {(inputs: Exercise_Personal_Goal_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva obiettivo`)
};

/**
* | output |
* | --- |
* | "Save goal" |
*
* @param {Exercise_Personal_Goal_SaveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_save = /** @type {((inputs?: Exercise_Personal_Goal_SaveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_SaveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_save(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_save(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_save(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_save(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_save(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_save(inputs)
	return en_us2_exercise_personal_goal_save(inputs)
});
export { exercise_personal_goal_save as "exercise-personal.goal_save" }